import { render, staticRenderFns } from "./Localisation.vue?vue&type=template&id=3c312abe&scoped=true&"
import script from "./Localisation.vue?vue&type=script&lang=js&"
export * from "./Localisation.vue?vue&type=script&lang=js&"
import style0 from "./Localisation.vue?vue&type=style&index=0&id=3c312abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c312abe",
  null
  
)

export default component.exports